import * as React from 'react';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getSession, removeSession, useAppSelector } from '@wappsto/redux';
import { App } from 'antd';
import { useTranslation } from 'translations';
import Cookies from 'util/cookies';
import { LINKS } from 'configuration';
import { ModalFuncWithPromise } from "antd/es/modal/useModal";

const InvalidSession = React.memo(({ children = null }: React.PropsWithChildren) => {
  const dispatch = useDispatch();
  const session = useAppSelector(getSession);
  const { tC } = useTranslation('features', 'validateSession');
  const modalRef = useRef<false | ReturnType<ModalFuncWithPromise>>(false);
  const { modal } = App.useApp();
  const navigate = useNavigate();

  useEffect(() => {
    if ((!session || !session.valid) && modalRef.current === false) {
      modalRef.current = modal.error({
        title: tC('invalidSession'),
        okText: tC('goToLoginButton'),
        onOk: () => {
          dispatch(removeSession());
          Cookies.remove('sessionID');
          navigate(LINKS.login, { replace: true });
        },
      });
    }
    return () => {
      if (modalRef.current) {
        modalRef.current.destroy();
      }
    };
  }, [dispatch, session, tC, modalRef, modal, navigate]);

  return children;
});

InvalidSession.displayName = 'InvalidSession';

export default InvalidSession;
